import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './event.types';
import * as constants from './event.constants';

export const storeEvent = generateStoreResourceAction<types.IEvent>(constants.STORE_EVENT);
export const clearEvent = generateClearResourceAction(constants.CLEAR_EVENT);
